import { ActionItem } from '../../libs/gs-component-form';
import { IconButton } from '../IconButton';
import { IconName } from '@xo-union/dist-iconography';
import React from 'react';

interface ActionButtonProps {
  onClick: () => void;
  expanded: boolean;
  hasPopup: boolean;
  text?: string | React.ReactNode;
  icon?: string;
  className?: string;
  size?: string;
  iconSize?: 'sm' | 'md' | 'lg' | undefined;
}

export const ActionButton = ({
  expanded,
  hasPopup,
  text,
  icon,
  className,
  size,
  iconSize,
  ...rest
}: ActionButtonProps) => {
  return !!icon ? (
    ((
      <IconButton
        name={icon as IconName}
        className={className}
        datatestid="dropdown_button"
        arialabel="dropdown_button"
        ariaHasPopup={hasPopup}
        expanded={expanded}
        size={iconSize}
        {...rest}
      />
    ) as any)
  ) : (
    <ActionItem type="add" data-testid="dropdown_button" aria-haspopup={hasPopup} aria-expanded={expanded} {...rest}>
      {!!text ? text : null}
    </ActionItem>
  );
};
